<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form" >
          <a-form-item label="发票名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input allow-clear v-decorator="['invoice_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item label="发票代码" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input allow-clear v-decorator="['invoice_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item label="发票号码" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input allow-clear v-decorator="['invoice_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item label="发票数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number allow-clear :precision="2" style="width: 50%" v-decorator="['invoice_quantity', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item label="发票金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number allow-clear :precision="4" style="width: 50%" v-decorator="['invoice_amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item label="发票日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-date-picker
              style="width: 100%"
              allow-clear
              v-decorator="['invoice_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
              format="YYYY-MM-DD"
              placeholder="发票日期"
              value-format="yyyy-MM-DD"
            />
          </a-form-item>
          <a-form-item v-bind="buttonCol">
            <a-row>
              <a-col span="6">
                <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
              </a-col>
              <a-col span="10">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
              <a-col span="8"></a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { fapiao_information_list, fapiao_information_update } from '@/api/trade_fapiao'

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      currency: this.$Dictionaries.currency,
      unit: this.$Dictionaries.unit,
      data: {},
      loading: false
    }
  },
  mounted () {
    this.loadFaPiaoInformationData()
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadFaPiaoInformationData () {
      this.id = this.$route.params.id
      this.loading = true
      fapiao_information_list({ id: this.$route.params.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.loadEditInfo(this.data)
          }
        }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          this.loading = true
          fapiao_information_update(values, this.id).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, ['id', 'invoice_name', 'invoice_code', 'invoice_number', 'invoice_quantity', 'invoice_amount', 'invoice_date'])
        form.setFieldsValue(formData)
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
